import { useTranslation } from 'react-i18next';
import useAppModal from 'hooks/useAppModal';
import { Lead } from 'models/Leads';
import { PreAuthorization } from 'models/securityDeposits/PreAuthorizations';
import PreAuthorizationChargeModal from './PreAuthorizationChargeModal';

const preAuthorizationChargeModalId = 'pre-authorization-charge-modal';

const usePreAuthorizationChargeModal = () => {
  const { openModal } = useAppModal();
  const { t } = useTranslation();

  const openPreAuthorizationChargeModal = ({
    lead,
    preAuthorization,
  }: {
    lead: Lead;
    preAuthorization: Pick<
      PreAuthorization,
      | 'status'
      | 'startAt'
      | 'expiresAt'
      | 'currency'
      | 'remainingAmount'
      | 'uid'
    >;
  }) => {
    openModal({
      customContent: (
        <PreAuthorizationChargeModal
          lead={lead}
          preAuthorization={preAuthorization}
        />
      ),
      id: preAuthorizationChargeModalId,
      title: t(
        'componentOrder.securityDepositPreAuthorization.chargeModal.title',
      ),
    });
  };

  return { openPreAuthorizationChargeModal };
};

export default usePreAuthorizationChargeModal;
